(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var loadedAtField = document.getElementById('ContactForm-loaded-at');
    if (loadedAtField) loadedAtField.value = String(Date.now());

    form.addEventListener('submit', function (e) {
      var honeypot = document.getElementById('ContactForm-website');
      if (honeypot && honeypot.value.trim() !== '') {
        e.preventDefault();
        return;
      }
      var loadedAt = loadedAtField ? parseInt(loadedAtField.value, 10) : 0;
      if (loadedAt && Date.now() - loadedAt < 2500) {
        e.preventDefault();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-collection-tracker-magic"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.nx-deckbuilder');
    if (!root) return;

    var cards = [];
    var config = window.nxCollectionConfig || {};
    var LOCAL_KEY = 'nx_collection_magic';
    var owned = {}; // card_id -> qty

    // Set metadata (logo + release date, for ordering newest-first) lives in
    // its own small static asset alongside the card data.
    var SET_META = {}; // set_id -> {name, logo, release_date}
    var SET_ORDER = []; // set_id list, newest release first

    function loadSetMeta() {
      return fetch(config.setsAssetUrl)
        .then(function (res) { return res.json(); })
        .then(function (list) {
          list.forEach(function (s) { SET_META[s.id] = s; });
          SET_ORDER = list.map(function (s) { return s.id; }); // already sorted newest-first
        })
        .catch(function () {});
    }

    function loadLocalOwned() {
      try {
        var raw = window.localStorage.getItem(LOCAL_KEY);
        owned = raw ? JSON.parse(raw) : {};
      } catch (e) {
        owned = {};
      }
    }
    function saveLocalOwned() {
      try {
        window.localStorage.setItem(LOCAL_KEY, JSON.stringify(owned));
      } catch (e) {}
    }

    // Card catalog data (name/image/rarity/colors/set) lives in a static
    // theme asset (assets/magic-cards.json, generated from Scryfall) instead
    // of live Shopify products — the catalog needs to keep showing every
    // known card (including sets/cards not currently stocked for sale)
    // regardless of any given card's product status.
    function loadAllCards(onBatch) {
      return fetch(config.cardsAssetUrl)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          cards.push.apply(cards, data);
          if (onBatch) onBatch();
        });
    }

    function updateOwnedSummary() {
      var total = Object.keys(owned).filter(function (id) { return owned[id] > 0; }).length;
      document.getElementById('nxOwnedCount').textContent = total;
    }

    function changeOwnedQty(id, delta) {
      var next = (owned[id] || 0) + delta;
      if (next <= 0) delete owned[id];
      else owned[id] = next;
      saveLocalOwned();
      updateOwnedSummary();
      renderGrid();
    }

    var COLS_KEY = 'nx_collection_cols';
    var columns = parseInt(window.localStorage.getItem(COLS_KEY), 10) || 4;

    function setColumns(n) {
      columns = n;
      try { window.localStorage.setItem(COLS_KEY, String(n)); } catch (e) {}
      document.getElementById('nxCardGrid').style.gridTemplateColumns = 'repeat(' + n + ', 1fr)';
      document.querySelectorAll('.nx-ct-cols__btn').forEach(function (btn) {
        btn.classList.toggle('is-active', parseInt(btn.getAttribute('data-cols'), 10) === n);
      });
    }

    document.querySelectorAll('.nx-ct-cols__btn').forEach(function (btn) {
      btn.addEventListener('click', function () { setColumns(parseInt(btn.getAttribute('data-cols'), 10)); });
    });

    var currentSet = null;

    function renderGrid() {
      var search = document.getElementById('nxSearch').value.toLowerCase();
      var colorFilter = document.getElementById('nxFilterType').value;
      var grid = document.getElementById('nxCardGrid');
      grid.innerHTML = '';

      var filtered = cards.filter(function (c) {
        if (currentSet && c.set_id !== currentSet) return false;
        if (search && c.name.toLowerCase().indexOf(search) === -1) return false;
        if (colorFilter && (c.colors || []).indexOf(colorFilter) === -1) return false;
        return true;
      }).slice(0, 300);

      filtered.forEach(function (c) {
        var qty = owned[c.id] || 0;
        var el = document.createElement('div');
        el.className = 'nx-ct-card' + (qty > 0 ? ' nx-ct-card--owned' : '');
        el.innerHTML =
          '<div class="nx-ct-card__media">' +
          (c.image ? '<img src="' + c.image + '" alt="' + c.name.replace(/"/g, '') + '" loading="lazy">' : '') +
          (qty > 0 ? '<span class="nx-ct-card__badge">×' + qty + '</span>' : '') +
          '<div class="nx-ct-card__actions">' +
          (qty > 0 ? '<button type="button" class="nx-ct-card__remove" aria-label="' + (qty > 1 ? config.strings.removeOne : config.strings.removeFromCollection) + '">' + (qty > 1 ? '−' : '×') + '</button>' : '') +
          '<button type="button" class="nx-ct-card__add" aria-label="' + config.strings.addToCollection + '">+</button>' +
          '</div>' +
          '</div>' +
          '<p class="nx-ct-card__name">' + c.name + '</p>' +
          '<p class="nx-ct-card__meta">' + (c.colors.length ? c.colors.join(', ') : config.strings.colorless) + (c.rarity ? ' · ' + c.rarity : '') + (!currentSet && c.set_label ? ' · ' + c.set_label : '') + '</p>';
        el.querySelector('.nx-ct-card__add').addEventListener('click', function (e) {
          e.stopPropagation();
          changeOwnedQty(c.id, 1);
        });
        var removeBtn = el.querySelector('.nx-ct-card__remove');
        if (removeBtn) {
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            changeOwnedQty(c.id, -1);
          });
        }
        grid.appendChild(el);
      });
    }

    function populateTypeFilter() {
      var colors = {};
      cards.forEach(function (c) { (c.colors || []).forEach(function (col) { colors[col] = true; }); });
      var typeSelect = document.getElementById('nxFilterType');
      while (typeSelect.options.length > 1) typeSelect.remove(1);
      Object.keys(colors).sort().forEach(function (t) {
        var opt = document.createElement('option');
        opt.value = t;
        opt.textContent = t;
        typeSelect.appendChild(opt);
      });
    }

    // Shown whenever a set is chosen, or a search is active across all sets.
    function updateView() {
      var searching = document.getElementById('nxSearch').value.trim().length > 0;
      var showCards = currentSet !== null || searching;
      document.getElementById('nxSetGridMagic').hidden = showCards;
      document.getElementById('nxCardBrowser').hidden = !showCards;
      document.getElementById('nxBackToSets').hidden = !currentSet;
      if (showCards) renderGrid(); else renderSetGrid();
    }

    function openSet(setId) {
      currentSet = setId;
      document.getElementById('nxSearch').value = '';
      document.getElementById('nxFilterType').value = '';
      updateView();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }

    function backToSets() {
      currentSet = null;
      document.getElementById('nxSearch').value = '';
      updateView();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }

    function progressColor(pct) {
      var from = [214, 76, 76]; // low progress: red
      var to = [93, 202, 165]; // full progress: brand teal-green (same as "owned" accent)
      var t = pct / 100;
      var rgb = from.map(function (c, i) { return Math.round(c + (to[i] - c) * t); });
      return 'rgb(' + rgb.join(',') + ')';
    }

    function renderSetGrid() {
      var sets = {}; // set_id -> {label, total, owned}
      cards.forEach(function (c) {
        if (!c.set_id) return;
        if (!sets[c.set_id]) sets[c.set_id] = {label: c.set_label, total: 0, owned: 0};
        sets[c.set_id].total++;
        if (owned[c.id] > 0) sets[c.set_id].owned++;
      });

      var grid = document.getElementById('nxSetGridMagic');
      grid.innerHTML = '';
      if (Object.keys(sets).length === 0) {
        grid.innerHTML = '<p class="nx-muted" style="font-size:13px;">' + config.strings.magicComingSoon + '</p>';
        return;
      }
      var orderedIds = Object.keys(sets).sort(function (a, b) {
        var ia = SET_ORDER.indexOf(a); if (ia === -1) ia = SET_ORDER.length;
        var ib = SET_ORDER.indexOf(b); if (ib === -1) ib = SET_ORDER.length;
        return ia - ib;
      });
      orderedIds.forEach(function (id) {
        var s = sets[id];
        var pct = s.total > 0 ? Math.round((s.owned / s.total) * 100) : 0;
        var logo = SET_META[id] && SET_META[id].logo;
        var el = document.createElement('div');
        el.className = 'nx-ct-setcard' + (pct === 100 ? ' nx-ct-setcard--complete' : '');
        el.innerHTML =
          '<div class="nx-ct-setcard__media">' +
          (logo
            ? '<img class="nx-ct-setcard__logo" src="' + logo + '" alt="' + s.label + '" loading="lazy">'
            : '<span class="nx-ct-setcard__fallback">' + s.label + '</span>') +
          '</div>' +
          '<div class="nx-ct-setcard__body">' +
          '<p class="nx-ct-setcard__name">' + s.label + '</p>' +
          '<p class="nx-ct-setcard__progress">' + s.owned + ' / ' + s.total + ' ' + config.strings.cardsOwned + '</p>' +
          '<div class="nx-ct-setcard__bar"><div class="nx-ct-setcard__bar-fill" style="width:' + pct + '%; background:' + progressColor(pct) + ';"></div></div>' +
          '</div>';
        el.addEventListener('click', function () { openSet(id); });
        grid.appendChild(el);
      });
    }

    function showStatus(text) {
      var el = document.getElementById('nxCollStatus');
      if (!el) return;
      el.textContent = text;
      el.style.display = 'block';
    }

    // Incoming sync from the account extension ("Charger depuis mon compte")
    (function handleIncomingSync() {
      var params = new URLSearchParams(window.location.search);
      var data = params.get('data');
      if (data) {
        try {
          owned = JSON.parse(decodeURIComponent(data));
          saveLocalOwned();
          showStatus(config.strings.syncLoaded);
        } catch (e) {}
      }
      if (params.get('synced') === '1') {
        showStatus(config.strings.syncSaved);
      }
    })();

    var loadBtn = document.getElementById('nxCollLoad');
    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        window.location.href = config.collectionAccountUrl + '?load=1&game=' + config.game;
      });
    }
    var saveBtn = document.getElementById('nxCollSave');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var encoded = encodeURIComponent(JSON.stringify(owned));
        window.location.href = config.collectionAccountUrl + '?save=' + encoded + '&game=' + config.game;
      });
    }

    document.getElementById('nxSearch').addEventListener('input', updateView);
    document.getElementById('nxFilterType').addEventListener('change', updateView);
    document.getElementById('nxBackToSets').addEventListener('click', backToSets);

    loadLocalOwned();
    updateOwnedSummary();
    setColumns(columns);

    var loadingEl = document.getElementById('nxLoading');
    Promise.all([loadSetMeta(), loadAllCards()])
      .then(function () {
        if (loadingEl) { loadingEl.remove(); loadingEl = null; }
        populateTypeFilter();
        updateOwnedSummary();
        updateView();
      })
      .catch(function () {
        if (loadingEl) loadingEl.textContent = config.strings.loadError;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-collection-tracker-onepiece"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.nx-deckbuilder');
    if (!root) return;

    var cards = [];
    var config = window.nxCollectionConfig || {};
    var LOCAL_KEY = 'nx_collection_onepiece';
    var owned = {}; // card_id -> qty

    // Set metadata (logo + release date, for ordering newest-first) lives in
    // its own small static asset alongside the card data. The "logo" here is
    // each set's Leader card art (no official set-logo asset exists in the
    // data source used).
    var SET_META = {}; // set_id -> {name, logo, release_date}
    var SET_ORDER = []; // set_id list, newest release first

    function loadSetMeta() {
      return fetch(config.setsAssetUrl)
        .then(function (res) { return res.json(); })
        .then(function (list) {
          list.forEach(function (s) { SET_META[s.id] = s; });
          SET_ORDER = list.map(function (s) { return s.id; }); // already sorted newest-first
        })
        .catch(function () {});
    }

    function loadLocalOwned() {
      try {
        var raw = window.localStorage.getItem(LOCAL_KEY);
        owned = raw ? JSON.parse(raw) : {};
      } catch (e) {
        owned = {};
      }
    }
    function saveLocalOwned() {
      try {
        window.localStorage.setItem(LOCAL_KEY, JSON.stringify(owned));
      } catch (e) {}
    }

    // Card catalog data (name/image/rarity/colors/type/set) lives in a static
    // theme asset (assets/onepiece-cards.json, generated from the optcgjson
    // open dataset) instead of live Shopify products — the catalog needs to
    // keep showing every known card regardless of any given card's product
    // status (most One Piece cards aren't sold individually yet).
    function loadAllCards(onBatch) {
      return fetch(config.cardsAssetUrl)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          cards.push.apply(cards, data);
          if (onBatch) onBatch();
        });
    }

    function updateOwnedSummary() {
      var total = Object.keys(owned).filter(function (id) { return owned[id] > 0; }).length;
      document.getElementById('nxOwnedCount').textContent = total;
    }

    function changeOwnedQty(id, delta) {
      var next = (owned[id] || 0) + delta;
      if (next <= 0) delete owned[id];
      else owned[id] = next;
      saveLocalOwned();
      updateOwnedSummary();
      renderGrid();
    }

    var COLS_KEY = 'nx_collection_cols';
    var columns = parseInt(window.localStorage.getItem(COLS_KEY), 10) || 4;

    function setColumns(n) {
      columns = n;
      try { window.localStorage.setItem(COLS_KEY, String(n)); } catch (e) {}
      document.getElementById('nxCardGrid').style.gridTemplateColumns = 'repeat(' + n + ', 1fr)';
      document.querySelectorAll('.nx-ct-cols__btn').forEach(function (btn) {
        btn.classList.toggle('is-active', parseInt(btn.getAttribute('data-cols'), 10) === n);
      });
    }

    document.querySelectorAll('.nx-ct-cols__btn').forEach(function (btn) {
      btn.addEventListener('click', function () { setColumns(parseInt(btn.getAttribute('data-cols'), 10)); });
    });

    var currentSet = null;

    function renderGrid() {
      var search = document.getElementById('nxSearch').value.toLowerCase();
      var colorFilter = document.getElementById('nxFilterType').value;
      var grid = document.getElementById('nxCardGrid');
      grid.innerHTML = '';

      var filtered = cards.filter(function (c) {
        if (currentSet && c.set_id !== currentSet) return false;
        if (search && c.name.toLowerCase().indexOf(search) === -1) return false;
        if (colorFilter && (c.colors || []).indexOf(colorFilter) === -1) return false;
        return true;
      }).slice(0, 300);

      filtered.forEach(function (c) {
        var qty = owned[c.id] || 0;
        var el = document.createElement('div');
        el.className = 'nx-ct-card' + (qty > 0 ? ' nx-ct-card--owned' : '');
        el.innerHTML =
          '<div class="nx-ct-card__media">' +
          (c.image ? '<img src="' + c.image + '" alt="' + c.name.replace(/"/g, '') + '" loading="lazy">' : '') +
          (qty > 0 ? '<span class="nx-ct-card__badge">×' + qty + '</span>' : '') +
          '<div class="nx-ct-card__actions">' +
          (qty > 0 ? '<button type="button" class="nx-ct-card__remove" aria-label="' + (qty > 1 ? config.strings.removeOne : config.strings.removeFromCollection) + '">' + (qty > 1 ? '−' : '×') + '</button>' : '') +
          '<button type="button" class="nx-ct-card__add" aria-label="' + config.strings.addToCollection + '">+</button>' +
          '</div>' +
          '</div>' +
          '<p class="nx-ct-card__name">' + c.name + '</p>' +
          '<p class="nx-ct-card__meta">' + (c.type || '') + (c.colors.length ? ' · ' + c.colors.join('/') : '') + (c.rarity ? ' · ' + c.rarity : '') + (!currentSet && c.set_label ? ' · ' + c.set_label : '') + '</p>';
        el.querySelector('.nx-ct-card__add').addEventListener('click', function (e) {
          e.stopPropagation();
          changeOwnedQty(c.id, 1);
        });
        var removeBtn = el.querySelector('.nx-ct-card__remove');
        if (removeBtn) {
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            changeOwnedQty(c.id, -1);
          });
        }
        grid.appendChild(el);
      });
    }

    function populateTypeFilter() {
      var colors = {};
      cards.forEach(function (c) { (c.colors || []).forEach(function (col) { colors[col] = true; }); });
      var typeSelect = document.getElementById('nxFilterType');
      while (typeSelect.options.length > 1) typeSelect.remove(1);
      Object.keys(colors).sort().forEach(function (t) {
        var opt = document.createElement('option');
        opt.value = t;
        opt.textContent = t;
        typeSelect.appendChild(opt);
      });
    }

    // Shown whenever a set is chosen, or a search is active across all sets.
    function updateView() {
      var searching = document.getElementById('nxSearch').value.trim().length > 0;
      var showCards = currentSet !== null || searching;
      document.getElementById('nxSetGridOnePiece').hidden = showCards;
      document.getElementById('nxCardBrowser').hidden = !showCards;
      document.getElementById('nxBackToSets').hidden = !currentSet;
      if (showCards) renderGrid(); else renderSetGrid();
    }

    function openSet(setId) {
      currentSet = setId;
      document.getElementById('nxSearch').value = '';
      document.getElementById('nxFilterType').value = '';
      updateView();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }

    function backToSets() {
      currentSet = null;
      document.getElementById('nxSearch').value = '';
      updateView();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }

    function progressColor(pct) {
      var from = [214, 76, 76]; // low progress: red
      var to = [93, 202, 165]; // full progress: brand teal-green (same as "owned" accent)
      var t = pct / 100;
      var rgb = from.map(function (c, i) { return Math.round(c + (to[i] - c) * t); });
      return 'rgb(' + rgb.join(',') + ')';
    }

    function renderSetGrid() {
      var sets = {}; // set_id -> {label, total, owned}
      cards.forEach(function (c) {
        if (!c.set_id) return;
        if (!sets[c.set_id]) sets[c.set_id] = {label: c.set_label, total: 0, owned: 0};
        sets[c.set_id].total++;
        if (owned[c.id] > 0) sets[c.set_id].owned++;
      });

      var grid = document.getElementById('nxSetGridOnePiece');
      grid.innerHTML = '';
      var orderedIds = Object.keys(sets).sort(function (a, b) {
        var ia = SET_ORDER.indexOf(a); if (ia === -1) ia = SET_ORDER.length;
        var ib = SET_ORDER.indexOf(b); if (ib === -1) ib = SET_ORDER.length;
        return ia - ib;
      });
      orderedIds.forEach(function (id) {
        var s = sets[id];
        var pct = s.total > 0 ? Math.round((s.owned / s.total) * 100) : 0;
        var logo = (config.setLogos && config.setLogos[id]) || (SET_META[id] && SET_META[id].logo);
        var el = document.createElement('div');
        el.className = 'nx-ct-setcard' + (pct === 100 ? ' nx-ct-setcard--complete' : '');
        el.innerHTML =
          '<div class="nx-ct-setcard__media">' +
          (logo
            ? '<img class="nx-ct-setcard__logo" src="' + logo + '" alt="' + s.label + '" loading="lazy">'
            : '<span class="nx-ct-setcard__fallback">' + s.label + '</span>') +
          '</div>' +
          '<div class="nx-ct-setcard__body">' +
          '<p class="nx-ct-setcard__name">' + s.label + '</p>' +
          '<p class="nx-ct-setcard__progress">' + s.owned + ' / ' + s.total + ' ' + config.strings.cardsOwned + '</p>' +
          '<div class="nx-ct-setcard__bar"><div class="nx-ct-setcard__bar-fill" style="width:' + pct + '%; background:' + progressColor(pct) + ';"></div></div>' +
          '</div>';
        el.addEventListener('click', function () { openSet(id); });
        grid.appendChild(el);
      });
    }

    function showStatus(text) {
      var el = document.getElementById('nxCollStatus');
      if (!el) return;
      el.textContent = text;
      el.style.display = 'block';
    }

    // Incoming sync from the account extension ("Charger depuis mon compte")
    (function handleIncomingSync() {
      var params = new URLSearchParams(window.location.search);
      var data = params.get('data');
      if (data) {
        try {
          owned = JSON.parse(decodeURIComponent(data));
          saveLocalOwned();
          showStatus(config.strings.syncLoaded);
        } catch (e) {}
      }
      if (params.get('synced') === '1') {
        showStatus(config.strings.syncSaved);
      }
    })();

    var loadBtn = document.getElementById('nxCollLoad');
    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        window.location.href = config.collectionAccountUrl + '?load=1&game=' + config.game;
      });
    }
    var saveBtn = document.getElementById('nxCollSave');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var encoded = encodeURIComponent(JSON.stringify(owned));
        window.location.href = config.collectionAccountUrl + '?save=' + encoded + '&game=' + config.game;
      });
    }

    document.getElementById('nxSearch').addEventListener('input', updateView);
    document.getElementById('nxFilterType').addEventListener('change', updateView);
    document.getElementById('nxBackToSets').addEventListener('click', backToSets);

    loadLocalOwned();
    updateOwnedSummary();
    setColumns(columns);

    var loadingEl = document.getElementById('nxLoading');
    Promise.all([loadSetMeta(), loadAllCards()])
      .then(function () {
        if (loadingEl) { loadingEl.remove(); loadingEl = null; }
        populateTypeFilter();
        updateOwnedSummary();
        updateView();
      })
      .catch(function () {
        if (loadingEl) loadingEl.textContent = config.strings.loadError;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-collection-tracker-pokemon"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.nx-deckbuilder');
    if (!root) return;

    var cards = [];
    var config = window.nxCollectionConfig || {};
    var LOCAL_KEY = 'nx_collection_pokemon';
    var owned = {}; // card_id -> qty

    // Set metadata (logo, era grouping, release date) lives in its own small
    // static asset alongside the card data — already sorted newest-first.
    var SET_META = {}; // set_id -> {name, logo, era_id, era_name, release_date}
    var SET_ORDER = []; // set_id list, newest release first
    var ERA_ORDER = []; // era_id list, in the order its newest set first appears

    function loadSetMeta() {
      return fetch(config.setsAssetUrl)
        .then(function (res) { return res.json(); })
        .then(function (list) {
          list.forEach(function (s) {
            SET_META[s.id] = s;
            if (s.era_id && ERA_ORDER.indexOf(s.era_id) === -1) ERA_ORDER.push(s.era_id);
          });
          SET_ORDER = list.map(function (s) { return s.id; });
        })
        .catch(function () {});
    }

    function loadLocalOwned() {
      try {
        var raw = window.localStorage.getItem(LOCAL_KEY);
        owned = raw ? JSON.parse(raw) : {};
      } catch (e) {
        owned = {};
      }
    }
    function saveLocalOwned() {
      try {
        window.localStorage.setItem(LOCAL_KEY, JSON.stringify(owned));
      } catch (e) {}
    }

    // Card catalog data (name/image/rarity/types/set) lives in a static
    // theme asset (assets/pokemon-cards.json, generated from TCGdex) instead
    // of live Shopify products — the catalog needs to keep showing every
    // known card (including sets/cards not currently stocked for sale)
    // regardless of any given card's product status.
    function loadAllCards(onBatch) {
      return fetch(config.cardsAssetUrl)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          cards.push.apply(cards, data);
          if (onBatch) onBatch();
        });
    }
    function updateOwnedSummary() {
      var total = Object.keys(owned).filter(function (id) { return owned[id] > 0; }).length;
      document.getElementById('nxOwnedCount').textContent = total;
    }

    function changeOwnedQty(id, delta) {
      var next = (owned[id] || 0) + delta;
      if (next <= 0) delete owned[id];
      else owned[id] = next;
      saveLocalOwned();
      updateOwnedSummary();
      renderGrid();
    }

    var COLS_KEY = 'nx_collection_cols';
    var columns = parseInt(window.localStorage.getItem(COLS_KEY), 10) || 4;

    function setColumns(n) {
      columns = n;
      try { window.localStorage.setItem(COLS_KEY, String(n)); } catch (e) {}
      document.getElementById('nxCardGrid').style.gridTemplateColumns = 'repeat(' + n + ', 1fr)';
      document.querySelectorAll('.nx-ct-cols__btn').forEach(function (btn) {
        btn.classList.toggle('is-active', parseInt(btn.getAttribute('data-cols'), 10) === n);
      });
    }

    document.querySelectorAll('.nx-ct-cols__btn').forEach(function (btn) {
      btn.addEventListener('click', function () { setColumns(parseInt(btn.getAttribute('data-cols'), 10)); });
    });

    var currentSet = null;

    function renderGrid() {
      var search = document.getElementById('nxSearch').value.toLowerCase();
      var typeFilter = document.getElementById('nxFilterType').value;
      var grid = document.getElementById('nxCardGrid');
      grid.innerHTML = '';

      var filtered = cards.filter(function (c) {
        if (currentSet && c.set_id !== currentSet) return false;
        if (search && c.name.toLowerCase().indexOf(search) === -1) return false;
        if (typeFilter && c.type !== typeFilter) return false;
        return true;
      }).slice(0, 300);

      filtered.forEach(function (c) {
        var qty = owned[c.id] || 0;
        var el = document.createElement('div');
        el.className = 'nx-ct-card' + (qty > 0 ? ' nx-ct-card--owned' : '');
        el.innerHTML =
          '<div class="nx-ct-card__media">' +
          (c.image ? '<img src="' + c.image + '" alt="' + c.name.replace(/"/g, '') + '" loading="lazy">' : '') +
          (qty > 0 ? '<span class="nx-ct-card__badge">×' + qty + '</span>' : '') +
          '<div class="nx-ct-card__actions">' +
          (qty > 0 ? '<button type="button" class="nx-ct-card__remove" aria-label="' + (qty > 1 ? config.strings.removeOne : config.strings.removeFromCollection) + '">' + (qty > 1 ? '−' : '×') + '</button>' : '') +
          '<button type="button" class="nx-ct-card__add" aria-label="' + config.strings.addToCollection + '">+</button>' +
          '</div>' +
          '</div>' +
          '<p class="nx-ct-card__name">' + c.name + '</p>' +
          '<p class="nx-ct-card__meta">' + (c.types.length ? c.types.join(', ') : c.type || '') + (c.rarity ? ' · ' + c.rarity : '') + (!currentSet && c.set_label ? ' · ' + c.set_label : '') + '</p>';
        el.querySelector('.nx-ct-card__add').addEventListener('click', function (e) {
          e.stopPropagation();
          changeOwnedQty(c.id, 1);
        });
        var removeBtn = el.querySelector('.nx-ct-card__remove');
        if (removeBtn) {
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            changeOwnedQty(c.id, -1);
          });
        }
        grid.appendChild(el);
      });
    }

    function populateTypeFilter() {
      var types = {};
      cards.forEach(function (c) { if (c.type) types[c.type] = true; });
      var typeSelect = document.getElementById('nxFilterType');
      while (typeSelect.options.length > 1) typeSelect.remove(1);
      Object.keys(types).sort().forEach(function (t) {
        var opt = document.createElement('option');
        opt.value = t;
        opt.textContent = t;
        typeSelect.appendChild(opt);
      });
    }

    // Shown whenever a set is chosen, or a search is active across all sets.
    function updateView() {
      var searching = document.getElementById('nxSearch').value.trim().length > 0;
      var showCards = currentSet !== null || searching;
      document.getElementById('nxSetsView').hidden = showCards;
      document.getElementById('nxCardBrowser').hidden = !showCards;
      document.getElementById('nxBackToSets').hidden = !currentSet;
      if (showCards) renderGrid(); else renderSetGrid();
    }

    function openSet(setId) {
      currentSet = setId;
      document.getElementById('nxSearch').value = '';
      document.getElementById('nxFilterType').value = '';
      updateView();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }

    function backToSets() {
      currentSet = null;
      document.getElementById('nxSearch').value = '';
      updateView();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }

    function progressColor(pct) {
      var from = [214, 76, 76]; // low progress: red
      var to = [93, 202, 165]; // full progress: brand teal-green (same as "owned" accent)
      var t = pct / 100;
      var rgb = from.map(function (c, i) { return Math.round(c + (to[i] - c) * t); });
      return 'rgb(' + rgb.join(',') + ')';
    }

    function makeSetCard(id, s) {
      var pct = s.total > 0 ? Math.round((s.owned / s.total) * 100) : 0;
      var logo = SET_META[id] && SET_META[id].logo;
      var el = document.createElement('div');
      el.className = 'nx-ct-setcard' + (pct === 100 ? ' nx-ct-setcard--complete' : '');
      el.innerHTML =
        '<div class="nx-ct-setcard__media">' +
        (logo
          ? '<img class="nx-ct-setcard__logo" src="' + logo + '" alt="' + s.label + '" loading="lazy">'
          : '<span class="nx-ct-setcard__fallback">' + s.label + '</span>') +
        '</div>' +
        '<div class="nx-ct-setcard__body">' +
        '<p class="nx-ct-setcard__name">' + s.label + '</p>' +
        '<p class="nx-ct-setcard__progress">' + s.owned + ' / ' + s.total + ' ' + config.strings.cardsOwned + '</p>' +
        '<div class="nx-ct-setcard__bar"><div class="nx-ct-setcard__bar-fill" style="width:' + pct + '%; background:' + progressColor(pct) + ';"></div></div>' +
        '</div>';
      el.addEventListener('click', function () { openSet(id); });
      return el;
    }

    // Sets are grouped under an "era" heading (Sword & Shield, XY, Base...)
    // matching how the Pokémon TCG's own history is commonly organized —
    // most recent era first, most recent set first within each era.
    function renderSetGrid() {
      var sets = {}; // set_id -> {label, total, owned}
      cards.forEach(function (c) {
        if (!c.set_id) return;
        if (!sets[c.set_id]) sets[c.set_id] = {label: c.set_label, total: 0, owned: 0};
        sets[c.set_id].total++;
        if (owned[c.id] > 0) sets[c.set_id].owned++;
      });

      var byEra = {}; // era_id ("" for unknown) -> set_id[]
      var eraLabel = {};
      Object.keys(sets).forEach(function (id) {
        var meta = SET_META[id];
        var eraId = (meta && meta.era_id) || '';
        if (!byEra[eraId]) { byEra[eraId] = []; eraLabel[eraId] = (meta && meta.era_name) || config.strings.otherSets; }
        byEra[eraId].push(id);
      });

      var orderedEraIds = ERA_ORDER.filter(function (e) { return byEra[e]; });
      Object.keys(byEra).forEach(function (e) { if (orderedEraIds.indexOf(e) === -1) orderedEraIds.push(e); });

      var grid = document.getElementById('nxSetGridPokemon');
      grid.innerHTML = '';
      orderedEraIds.forEach(function (eraId) {
        var setIds = byEra[eraId].sort(function (a, b) {
          var ia = SET_ORDER.indexOf(a); if (ia === -1) ia = SET_ORDER.length;
          var ib = SET_ORDER.indexOf(b); if (ib === -1) ib = SET_ORDER.length;
          return ia - ib;
        });
        var section = document.createElement('div');
        section.className = 'nx-ct-era-section';
        section.id = 'era-' + (eraId || 'other');
        var heading = document.createElement('h3');
        heading.className = 'nx-ct-era-heading';
        heading.textContent = eraLabel[eraId];
        section.appendChild(heading);
        var eraGrid = document.createElement('div');
        eraGrid.className = 'nx-ct-setgrid__era';
        setIds.forEach(function (id) { eraGrid.appendChild(makeSetCard(id, sets[id])); });
        section.appendChild(eraGrid);
        grid.appendChild(section);
      });

      renderEraNav(orderedEraIds, eraLabel);
    }

    function renderEraNav(orderedEraIds, eraLabel) {
      var nav = document.getElementById('nxEraNav');
      if (!nav) return;
      var html = '<p class="nx-ct-eranav__title">' + config.strings.eraNavTitle + '</p>';
      orderedEraIds.forEach(function (eraId) {
        var anchor = 'era-' + (eraId || 'other');
        html += '<a class="nx-ct-eranav__link" data-era="' + anchor + '" href="#' + anchor + '">' + eraLabel[eraId] + '</a>';
      });
      nav.innerHTML = html;

      var links = nav.querySelectorAll('.nx-ct-eranav__link');
      links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(link.getAttribute('data-era'));
          if (target) target.scrollIntoView({behavior: 'smooth', block: 'start'});
        });
      });

      if ('IntersectionObserver' in window) {
        var sections = document.querySelectorAll('.nx-ct-era-section');
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-era') === entry.target.id); });
          });
        }, {rootMargin: '-100px 0px -70% 0px'});
        sections.forEach(function (s) { observer.observe(s); });
      }
    }

    function showStatus(text) {
      var el = document.getElementById('nxCollStatus');
      if (!el) return;
      el.textContent = text;
      el.style.display = 'block';
    }

    // Incoming sync from the account extension ("Charger depuis mon compte")
    (function handleIncomingSync() {
      var params = new URLSearchParams(window.location.search);
      var data = params.get('data');
      if (data) {
        try {
          owned = JSON.parse(decodeURIComponent(data));
          saveLocalOwned();
          showStatus(config.strings.syncLoaded);
        } catch (e) {}
      }
      if (params.get('synced') === '1') {
        showStatus(config.strings.syncSaved);
      }
    })();

    var loadBtn = document.getElementById('nxCollLoad');
    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        window.location.href = config.collectionAccountUrl + '?load=1&game=' + config.game;
      });
    }
    var saveBtn = document.getElementById('nxCollSave');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var encoded = encodeURIComponent(JSON.stringify(owned));
        window.location.href = config.collectionAccountUrl + '?save=' + encoded + '&game=' + config.game;
      });
    }

    document.getElementById('nxSearch').addEventListener('input', updateView);
    document.getElementById('nxFilterType').addEventListener('change', updateView);
    document.getElementById('nxBackToSets').addEventListener('click', backToSets);

    loadLocalOwned();
    updateOwnedSummary();
    setColumns(columns);

    var loadingEl = document.getElementById('nxLoading');
    Promise.all([loadSetMeta(), loadAllCards()])
      .then(function () {
        if (loadingEl) { loadingEl.remove(); loadingEl = null; }
        populateTypeFilter();
        updateOwnedSummary();
        updateView();
      })
      .catch(function () {
        if (loadingEl) loadingEl.textContent = config.strings.loadError;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-collection-tracker"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.nx-deckbuilder');
    if (!root) return;

    var cards = [];
    var config = window.nxCollectionConfig || {};
    var LOCAL_KEY = 'nx_collection';
    var owned = {}; // riftbound_id -> qty

    var SET_LOGOS = {
      VEN: 'https://pressreleases.triplepointpr.com/wp-content/uploads/SET04_Vendetta_Wordmark.png',
      UNL: 'https://pressreleases.triplepointpr.com/wp-content/uploads/Riftbound_Unleashed_Logo_RGB-1-scaled.png',
      // No clean wordmark-only asset found yet for these — falls back to a styled set-code badge (see renderSetGrid).
      SFD: null,
      OGN: null,
      RAD: null,
    };
    // Newest release first; unknown sets are appended at the end in whatever order they're found.
    var SET_ORDER = ['RAD', 'VEN', 'UNL', 'SFD', 'OGN'];

    function loadLocalOwned() {
      try {
        var raw = window.localStorage.getItem(LOCAL_KEY);
        owned = raw ? JSON.parse(raw) : {};
      } catch (e) {
        owned = {};
      }
    }
    function saveLocalOwned() {
      try {
        window.localStorage.setItem(LOCAL_KEY, JSON.stringify(owned));
      } catch (e) {}
    }

    function storefrontQuery(query, variables) {
      return fetch(config.storefrontUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.storefrontToken,
        },
        body: JSON.stringify({query: query, variables: variables}),
      }).then(function (res) { return res.json(); });
    }

    var CARDS_QUERY =
      'query Cards($filter: String!, $cursor: String) {' +
      '  products(first: 250, after: $cursor, query: $filter) {' +
      '    pageInfo { hasNextPage endCursor }' +
      '    nodes {' +
      '      handle' +
      '      title' +
      '      availableForSale' +
      '      featuredImage { url }' +
      '      variants(first: 1) { nodes { id price { amount currencyCode } } }' +
      '      metafields(identifiers: [' +
      '        {namespace: "riftbound", key: "riftbound_id"},' +
      '        {namespace: "riftbound", key: "card_type"},' +
      '        {namespace: "riftbound", key: "rarity"},' +
      '        {namespace: "riftbound", key: "energy"},' +
      '        {namespace: "riftbound", key: "might"},' +
      '        {namespace: "riftbound", key: "domains"},' +
      '        {namespace: "riftbound", key: "set_id"},' +
      '        {namespace: "riftbound", key: "set_label"}' +
      '      ]) { key value }' +
      '    }' +
      '  }' +
      '}';

    function fieldsToCard(node) {
      var map = {};
      node.metafields.forEach(function (f) { if (f) map[f.key] = f.value; });
      var domains = [];
      try { domains = JSON.parse(map.domains || '[]'); } catch (e) {}
      return {
        id: map.riftbound_id,
        name: node.title,
        image: node.featuredImage ? node.featuredImage.url : null,
        type: map.card_type,
        rarity: map.rarity,
        energy: map.energy ? parseInt(map.energy, 10) : null,
        domains: domains,
        set_id: map.set_id,
        set_label: map.set_label,
      };
    }

    function cardById(id) {
      return cards.find(function (c) { return c.id === id; });
    }

    function loadAllCards(onBatch) {
      var filter = 'vendor:Riftbound AND product_type:"Carte à l\'unité"';
      var cursor = null;
      function loadPage() {
        return storefrontQuery(CARDS_QUERY, {filter: filter, cursor: cursor}).then(function (res) {
          var conn = res.data && res.data.products;
          if (!conn) return;
          var batch = [];
          conn.nodes.forEach(function (n) {
            if (n.metafields.some(function (f) { return f; })) batch.push(fieldsToCard(n));
          });
          cards.push.apply(cards, batch);
          if (onBatch) onBatch();
          if (conn.pageInfo.hasNextPage) {
            cursor = conn.pageInfo.endCursor;
            return loadPage();
          }
        });
      }
      return loadPage();
    }

    function updateOwnedSummary() {
      var total = Object.keys(owned).filter(function (id) { return owned[id] > 0; }).length;
      document.getElementById('nxOwnedCount').textContent = total;
    }

    function changeOwnedQty(id, delta) {
      var next = (owned[id] || 0) + delta;
      if (next <= 0) delete owned[id];
      else owned[id] = next;
      saveLocalOwned();
      updateOwnedSummary();
      renderGrid();
    }

    var COLS_KEY = 'nx_collection_cols';
    var columns = parseInt(window.localStorage.getItem(COLS_KEY), 10) || 4;

    function setColumns(n) {
      columns = n;
      try { window.localStorage.setItem(COLS_KEY, String(n)); } catch (e) {}
      document.getElementById('nxCardGrid').style.gridTemplateColumns = 'repeat(' + n + ', 1fr)';
      document.querySelectorAll('.nx-ct-cols__btn').forEach(function (btn) {
        btn.classList.toggle('is-active', parseInt(btn.getAttribute('data-cols'), 10) === n);
      });
    }

    document.querySelectorAll('.nx-ct-cols__btn').forEach(function (btn) {
      btn.addEventListener('click', function () { setColumns(parseInt(btn.getAttribute('data-cols'), 10)); });
    });

    var currentSet = null;

    function renderGrid() {
      var search = document.getElementById('nxSearch').value.toLowerCase();
      var typeFilter = document.getElementById('nxFilterType').value;
      var domainFilter = document.getElementById('nxFilterDomain').value;
      var grid = document.getElementById('nxCardGrid');
      grid.innerHTML = '';

      var filtered = cards.filter(function (c) {
        if (currentSet && c.set_id !== currentSet) return false;
        if (search && c.name.toLowerCase().indexOf(search) === -1) return false;
        if (typeFilter && c.type !== typeFilter) return false;
        if (domainFilter && (c.domains || []).indexOf(domainFilter) === -1) return false;
        return true;
      }).slice(0, 300);

      filtered.forEach(function (c) {
        var qty = owned[c.id] || 0;
        var el = document.createElement('div');
        el.className = 'nx-ct-card' + (qty > 0 ? ' nx-ct-card--owned' : '');
        el.innerHTML =
          '<div class="nx-ct-card__media">' +
          (c.image ? '<img src="' + c.image + '" alt="' + c.name.replace(/"/g, '') + '" loading="lazy">' : '') +
          (qty > 0 ? '<span class="nx-ct-card__badge">×' + qty + '</span>' : '') +
          '<div class="nx-ct-card__actions">' +
          (qty > 0 ? '<button type="button" class="nx-ct-card__remove" aria-label="' + (qty > 1 ? config.strings.removeOne : config.strings.removeFromCollection) + '">' + (qty > 1 ? '−' : '×') + '</button>' : '') +
          '<button type="button" class="nx-ct-card__add" aria-label="' + config.strings.addToCollection + '">+</button>' +
          '</div>' +
          '</div>' +
          '<p class="nx-ct-card__name">' + c.name + '</p>' +
          '<p class="nx-ct-card__meta">' + (c.energy != null ? config.strings.energyPrefix + ' ' + c.energy : c.type) + (!currentSet && c.set_label ? ' · ' + c.set_label : '') + '</p>';
        el.querySelector('.nx-ct-card__add').addEventListener('click', function (e) {
          e.stopPropagation();
          changeOwnedQty(c.id, 1);
        });
        var removeBtn = el.querySelector('.nx-ct-card__remove');
        if (removeBtn) {
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            changeOwnedQty(c.id, -1);
          });
        }
        grid.appendChild(el);
      });
    }

    function populateFilters() {
      var domains = {};
      cards.forEach(function (c) {
        (c.domains || []).forEach(function (d) { domains[d] = true; });
      });
      var domainSelect = document.getElementById('nxFilterDomain');
      while (domainSelect.options.length > 1) domainSelect.remove(1);
      Object.keys(domains).sort().forEach(function (d) {
        var opt = document.createElement('option');
        opt.value = d;
        opt.textContent = d;
        domainSelect.appendChild(opt);
      });
    }

    // Shown whenever a set is chosen, or a search is active across all sets.
    function updateView() {
      var searching = document.getElementById('nxSearch').value.trim().length > 0;
      var showCards = currentSet !== null || searching;
      document.getElementById('nxSetGrid').hidden = showCards;
      document.getElementById('nxCardBrowser').hidden = !showCards;
      document.getElementById('nxBackToSets').hidden = !currentSet;
      if (showCards) renderGrid(); else renderSetGrid();
    }

    function openSet(setId) {
      currentSet = setId;
      document.getElementById('nxSearch').value = '';
      document.getElementById('nxFilterType').value = '';
      document.getElementById('nxFilterDomain').value = '';
      updateView();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }

    function backToSets() {
      currentSet = null;
      document.getElementById('nxSearch').value = '';
      updateView();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }

    function progressColor(pct) {
      var from = [214, 76, 76]; // low progress: red
      var to = [93, 202, 165]; // full progress: brand teal-green (same as "owned" accent)
      var t = pct / 100;
      var rgb = from.map(function (c, i) { return Math.round(c + (to[i] - c) * t); });
      return 'rgb(' + rgb.join(',') + ')';
    }

    function renderSetGrid() {
      var sets = {}; // set_id -> {label, total, owned}
      cards.forEach(function (c) {
        if (!c.set_id) return;
        if (!sets[c.set_id]) sets[c.set_id] = {label: c.set_label, total: 0, owned: 0};
        sets[c.set_id].total++;
        if (owned[c.id] > 0) sets[c.set_id].owned++;
      });

      var grid = document.getElementById('nxSetGrid');
      grid.innerHTML = '';
      var orderedIds = Object.keys(sets).sort(function (a, b) {
        var ia = SET_ORDER.indexOf(a); if (ia === -1) ia = SET_ORDER.length;
        var ib = SET_ORDER.indexOf(b); if (ib === -1) ib = SET_ORDER.length;
        return ia - ib;
      });
      orderedIds.forEach(function (id) {
        var s = sets[id];
        var pct = s.total > 0 ? Math.round((s.owned / s.total) * 100) : 0;
        var photo = SET_LOGOS[id];
        var el = document.createElement('div');
        el.className = 'nx-ct-setcard' + (pct === 100 ? ' nx-ct-setcard--complete' : '');
        el.innerHTML =
          '<div class="nx-ct-setcard__media">' +
          (photo
            ? '<img class="nx-ct-setcard__photo" src="' + photo + '" alt="' + s.label + '" loading="lazy">'
            : '<div class="nx-ct-setcard__badge">' + id + '</div>') +
          '</div>' +
          '<div class="nx-ct-setcard__body">' +
          '<p class="nx-ct-setcard__name">' + s.label + '</p>' +
          '<p class="nx-ct-setcard__progress">' + s.owned + ' / ' + s.total + ' ' + config.strings.cardsOwned + '</p>' +
          '<div class="nx-ct-setcard__bar"><div class="nx-ct-setcard__bar-fill" style="width:' + pct + '%; background:' + progressColor(pct) + ';"></div></div>' +
          '</div>';
        el.addEventListener('click', function () { openSet(id); });
        grid.appendChild(el);
      });
    }

    function showStatus(text) {
      var el = document.getElementById('nxCollStatus');
      el.textContent = text;
      el.style.display = 'block';
    }

    // Incoming sync from the account extension ("Charger depuis mon compte")
    (function handleIncomingSync() {
      var params = new URLSearchParams(window.location.search);
      var data = params.get('data');
      if (data) {
        try {
          owned = JSON.parse(decodeURIComponent(data));
          saveLocalOwned();
          showStatus(config.strings.syncLoaded);
        } catch (e) {}
      }
      if (params.get('synced') === '1') {
        showStatus(config.strings.syncSaved);
      }
    })();

    var loadBtn = document.getElementById('nxCollLoad');
    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        window.location.href = config.collectionAccountUrl + '?load=1&game=riftbound';
      });
    }
    var saveBtn = document.getElementById('nxCollSave');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var encoded = encodeURIComponent(JSON.stringify(owned));
        window.location.href = config.collectionAccountUrl + '?save=' + encoded + '&game=riftbound';
      });
    }

    document.getElementById('nxSearch').addEventListener('input', updateView);
    document.getElementById('nxFilterType').addEventListener('change', updateView);
    document.getElementById('nxFilterDomain').addEventListener('change', updateView);
    document.getElementById('nxBackToSets').addEventListener('click', backToSets);

    loadLocalOwned();
    updateOwnedSummary();
    setColumns(columns);

    var loadingEl = document.getElementById('nxLoading');
    loadAllCards(function () {
      if (loadingEl) { loadingEl.remove(); loadingEl = null; }
      populateFilters();
      updateOwnedSummary();
      updateView();
    }).catch(function () {
      if (loadingEl) loadingEl.textContent = config.strings.loadError;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('NxCollectionSearch');
    var grid = document.getElementById('NxCollectionGrid');
    if (!input || !grid) return;
    var emptyEl = document.getElementById('NxCollectionSearchEmpty');
    var config = window.nxCollectionSearchConfig || {};
    var originalGridHtml = grid.innerHTML;
    var debounceTimer = null;
    var requestSeq = 0;

    function moneyFormat(amount, currency) {
      try {
        return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: currency}).format(amount);
      } catch (e) {
        return amount + ' ' + currency;
      }
    }

    function cardHtml(p) {
      var variant = p.variants.nodes[0];
      var releaseDate = p.releaseDateField && p.releaseDateField.value;
      var isPreorder = false;
      if (releaseDate) {
        var today = new Date().toISOString().slice(0, 10);
        if (releaseDate > today) isPreorder = true;
      }
      var badge = '';
      if (isPreorder) {
        var parts = releaseDate.split('-');
        var formatted = parts[2] + '/' + parts[1] + '/' + parts[0];
        badge = '<span class="nx-card__badge nx-card__badge--preorder">Précommande — ' + formatted + '</span>';
      } else if (!p.availableForSale) {
        badge = '<span class="nx-card__badge nx-card__badge--soldout">Épuisé</span>';
      }
      var img = p.featuredImage
        ? '<img src="' + p.featuredImage.url + '" alt="' + p.title.replace(/"/g, '') + '" loading="lazy">'
        : '';
      var price = variant ? moneyFormat(variant.price.amount, variant.price.currencyCode) : '';
      return (
        '<a href="/products/' + p.handle + '" class="nx-card">' +
        '<div class="nx-img nx-card__image">' + badge + img + '</div>' +
        '<p class="nx-card__name">' + p.title + '</p>' +
        '<p class="nx-card__price">' + price + '</p>' +
        '</a>'
      );
    }

    function runSearch(term) {
      var seq = ++requestSeq;
      var filter = 'product_type:"Carte à l\'unité" AND title:*' + term.replace(/"/g, '') + '*';
      if (config.vendorFilter) filter = 'vendor:"' + config.vendorFilter + '" AND ' + filter;

      var query =
        'query($filter: String!) {' +
        '  products(first: 48, query: $filter) {' +
        '    nodes {' +
        '      handle title availableForSale featuredImage { url }' +
        '      variants(first: 1) { nodes { price { amount currencyCode } } }' +
        '      releaseDateField: metafield(namespace: "custom", key: "release_date") { value }' +
        '    }' +
        '  }' +
        '}';

      fetch(config.storefrontUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': config.storefrontToken},
        body: JSON.stringify({query: query, variables: {filter: filter}}),
      })
        .then(function (res) { return res.json(); })
        .then(function (res) {
          if (seq !== requestSeq) return; // a newer search superseded this one
          var nodes = (res.data && res.data.products && res.data.products.nodes) || [];
          if (nodes.length === 0) {
            grid.innerHTML = '';
            if (emptyEl) emptyEl.hidden = false;
          } else {
            grid.innerHTML = nodes.map(cardHtml).join('');
            if (emptyEl) emptyEl.hidden = true;
          }
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(debounceTimer);
      if (!term) {
        requestSeq++; // invalidate any in-flight search
        grid.innerHTML = originalGridHtml;
        if (emptyEl) emptyEl.hidden = true;
        return;
      }
      debounceTimer = setTimeout(function () { runSearch(term); }, 300);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-deck-builder"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.nx-deckbuilder');
    if (!root) return;

    var cards = [];
    var config = window.nxDeckBuilderConfig || {};

    function tr(key, vars) {
      var str = (config.strings && config.strings[key]) || key;
      if (vars) {
        Object.keys(vars).forEach(function (k) {
          str = str.split('{' + k + '}').join(vars[k]);
        });
      }
      return str;
    }

    function storefrontQuery(query, variables) {
      return fetch(config.storefrontUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.storefrontToken,
        },
        body: JSON.stringify({query: query, variables: variables}),
      }).then(function (res) { return res.json(); });
    }

    var CARDS_QUERY =
      'query Cards($filter: String!, $cursor: String) {' +
      '  products(first: 250, after: $cursor, query: $filter) {' +
      '    pageInfo { hasNextPage endCursor }' +
      '    nodes {' +
      '      handle' +
      '      title' +
      '      availableForSale' +
      '      featuredImage { url }' +
      '      variants(first: 1) { nodes { id price { amount currencyCode } } }' +
      '      metafields(identifiers: [' +
      '        {namespace: "riftbound", key: "riftbound_id"},' +
      '        {namespace: "riftbound", key: "card_type"},' +
      '        {namespace: "riftbound", key: "rarity"},' +
      '        {namespace: "riftbound", key: "energy"},' +
      '        {namespace: "riftbound", key: "might"},' +
      '        {namespace: "riftbound", key: "domains"},' +
      '        {namespace: "riftbound", key: "set_id"},' +
      '        {namespace: "riftbound", key: "set_label"}' +
      '      ]) { key value }' +
      '    }' +
      '  }' +
      '}';

    function fieldsToCard(node) {
      var map = {};
      node.metafields.forEach(function (f) { if (f) map[f.key] = f.value; });
      var variant = node.variants.nodes[0];
      var domains = [];
      try { domains = JSON.parse(map.domains || '[]'); } catch (e) {}
      return {
        id: map.riftbound_id,
        name: node.title,
        image: node.featuredImage ? node.featuredImage.url : null,
        type: map.card_type,
        rarity: map.rarity,
        energy: map.energy ? parseInt(map.energy, 10) : null,
        might: map.might ? parseInt(map.might, 10) : null,
        domains: domains,
        set_id: map.set_id,
        set_label: map.set_label,
        product: {
          url: '/products/' + node.handle,
          available: node.availableForSale,
          price: variant ? variant.price.amount : null,
          currency: variant ? variant.price.currencyCode : null,
          variantId: variant ? variant.id : null,
        },
      };
    }

    function loadAllCards(onBatch) {
      var baseFilter = 'vendor:Riftbound AND product_type:"Carte à l\'unité"';

      function fetchAll(filter) {
        var cursor = null;
        function loadPage() {
          return storefrontQuery(CARDS_QUERY, {filter: filter, cursor: cursor}).then(function (res) {
            var conn = res.data && res.data.products;
            if (!conn) return;
            var batch = [];
            conn.nodes.forEach(function (n) {
              if (n.metafields.some(function (f) { return f; })) batch.push(fieldsToCard(n));
            });
            cards.push.apply(cards, batch);
            if (onBatch) onBatch();
            if (conn.pageInfo.hasNextPage) {
              cursor = conn.pageInfo.endCursor;
              return loadPage();
            }
          });
        }
        return loadPage();
      }

      // Champions first: small, fast batch so the champion picker is usable
      // right away instead of waiting on the full ~1300-card catalog.
      return fetchAll(baseFilter + ' AND tag:Legend').then(function () {
        return fetchAll(baseFilter + ' AND NOT tag:Legend');
      });
    }

    var state = {
      champion: null,
      main: {}, // id -> qty (max 3 copies per card, combined with sideboard)
      battlefields: {}, // id -> 1 (max 3 distinct, 1 copy each)
      runes: {}, // id -> qty
      sideboard: {}, // id -> qty (max 3 copies per card, combined with main)
    };

    // view.mode: 'champion' (step 1 picker) or 'workspace' (tabbed builder).
    // view.tab: which workspace tab is active ('battlefields' | 'runes' | 'main').
    var view = {mode: 'champion', tab: 'main'};

    var DOMAIN_COLORS = {
      Fury: '#D6534A',
      Calm: '#4FA8D8',
      Body: '#4CAF7D',
      Mind: '#9B6FE0',
      Order: '#E0B93D',
      Chaos: '#D967B0',
      Neutre: 'rgba(255,255,255,0.3)',
    };

    // Official Riftbound constructed-format rules.
    var RULES = {
      main: 40, // tournament rules 402.1: exactly 40 cards, chosen champion included (core rule 103.2 allows "at least" 40 for casual play)
      battlefields: 3,
      runes: 12,
      sideboardMax: 10,
      maxCopies: 3,
      maxColors: 2,
    };

    // Restore a deck passed via ?load= from the "Mes decks" account page
    (function restoreFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var loaded = params.get('load');
      if (!loaded) return;
      try {
        var deck = JSON.parse(decodeURIComponent(loaded));
        document.getElementById('nxDeckName').value = deck.name || tr('deckLoadedDefaultName');
        state.champion = deck.champion || null;
        (deck.main || []).forEach(function (c) { state.main[c.id] = c.qty; });
        (deck.battlefields || []).forEach(function (c) { state.battlefields[c.id] = 1; });
        (deck.runes || []).forEach(function (c) { state.runes[c.id] = c.qty; });
        (deck.sideboard || []).forEach(function (c) { state.sideboard[c.id] = c.qty; });
      } catch (e) {}
    })();

    function cardById(id) {
      return cards.find(function (c) { return c.id === id; });
    }

    // "Colorless" is how Battlefields/neutral cards are tagged — it isn't a
    // real domain restriction, so it must be ignored by champion-domain
    // legality checks (otherwise every Battlefield gets filtered out, since
    // ["Colorless"] never matches a champion's actual domains).
    function realDomains(list) {
      return (list || []).filter(function (d) { return d !== 'Colorless'; });
    }

    // ---- View switching (Champion picker <-> workspace tabs) ----

    function showChampionScreen() {
      view.mode = 'champion';
      document.getElementById('nxChampionScreen').hidden = false;
      document.getElementById('nxWorkspace').hidden = true;
      renderChampionGrid();
    }

    function showWorkspace(tab) {
      view.mode = 'workspace';
      view.tab = tab || 'battlefields';
      document.getElementById('nxChampionScreen').hidden = true;
      document.getElementById('nxWorkspace').hidden = false;
      updateTabsUI();
      renderGrid();
    }

    function updateTabsUI() {
      document.querySelectorAll('.nx-db-tab').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-tab') === view.tab);
      });
      var typeSelect = document.getElementById('nxFilterType');
      typeSelect.style.display = view.tab === 'main' ? '' : 'none';
      var setSelect = document.getElementById('nxFilterSet');
      setSelect.style.display = view.tab === 'runes' ? 'none' : '';
    }

    document.querySelectorAll('.nx-db-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        view.tab = btn.getAttribute('data-tab');
        // Reset filters on tab switch: a domain/set filter left over from another
        // tab could otherwise make the new tab look empty for no visible reason.
        document.getElementById('nxSearch').value = '';
        document.getElementById('nxFilterDomain').value = '';
        document.getElementById('nxFilterSet').value = '';
        document.getElementById('nxFilterType').value = '';
        updateTabsUI();
        renderGrid();
      });
    });

    document.getElementById('nxChangeChampionBtn').addEventListener('click', showChampionScreen);

    // ---- Card rendering (shared between champion grid and workspace grid) ----

    function cardBadge(c) {
      var qtyInDeck = state.champion === c.id ? 1 :
        (state.main[c.id] || state.battlefields[c.id] || state.runes[c.id] || state.sideboard[c.id] || 0);
      if (qtyInDeck <= 0) return '';
      return '<span class="nx-db-card__badge">' + (c.type === 'Legend' ? '✓' : '×' + qtyInDeck) + '</span>';
    }

    function renderChampionGrid() {
      var loading = document.getElementById('nxChampionLoading');
      var grid = document.getElementById('nxChampionGrid');
      var search = document.getElementById('nxChampionSearch').value.toLowerCase();
      var domainFilter = document.getElementById('nxChampionDomainFilter').value;
      var champions = cards.filter(function (c) { return c.type === 'Legend'; });
      if (loading) loading.style.display = champions.length ? 'none' : 'block';
      grid.innerHTML = '';

      champions
        .filter(function (c) {
          if (search && c.name.toLowerCase().indexOf(search) === -1) return false;
          if (domainFilter && (c.domains || []).indexOf(domainFilter) === -1) return false;
          return true;
        })
        .forEach(function (c) {
          var el = document.createElement('div');
          el.className = 'nx-db-champion-card';
          var domainDots = realDomains(c.domains).map(function (d) {
            var color = DOMAIN_COLORS[d] || DOMAIN_COLORS.Neutre;
            return '<span class="nx-db-champion-card__domain-dot" style="background:' + color + ';" title="' + d + '"></span>';
          }).join('');
          el.innerHTML =
            (c.image ? '<img src="' + c.image + '" alt="' + c.name.replace(/"/g, '') + '" loading="lazy">' : '') +
            '<p class="nx-db-champion-card__name">' + c.name + '</p>' +
            '<div class="nx-db-champion-card__domains">' + domainDots + '</div>';
          el.addEventListener('click', function () { openDetail(c); });
          grid.appendChild(el);
        });
    }

    function renderGrid() {
      if (view.mode !== 'workspace') return;
      var search = document.getElementById('nxSearch').value.toLowerCase();
      var typeFilter = document.getElementById('nxFilterType').value;
      var domainFilter = document.getElementById('nxFilterDomain').value;
      var setFilter = document.getElementById('nxFilterSet').value;
      var grid = document.getElementById('nxCardGrid');
      grid.innerHTML = '';

      var strict = document.getElementById('nxStrictMode').checked;
      var champion = state.champion ? cardById(state.champion) : null;
      var allowedDomains = champion ? (champion.domains || []) : null;
      var hint = document.getElementById('nxDomainHint');
      if (hint) hint.style.display = strict && allowedDomains && view.tab === 'main' ? 'block' : 'none';

      var filtered = cards.filter(function (c) {
        if (view.tab === 'battlefields') {
          if (c.type !== 'Battlefield') return false;
        } else if (view.tab === 'runes') {
          if (c.type !== 'Rune') return false;
        } else {
          if (c.type === 'Legend' || c.type === 'Battlefield' || c.type === 'Rune') return false;
          if (typeFilter && c.type !== typeFilter) return false;
        }
        if (search && c.name.toLowerCase().indexOf(search) === -1) return false;
        if (domainFilter && (c.domains || []).indexOf(domainFilter) === -1) return false;
        if (setFilter && c.set_id !== setFilter) return false;
        if (strict && allowedDomains) {
          var cardDomains = realDomains(c.domains);
          var legal = cardDomains.length === 0 || cardDomains.some(function (d) { return allowedDomains.indexOf(d) !== -1; });
          if (!legal) return false;
        }
        return true;
      }).slice(0, 300);

      filtered.forEach(function (c) {
        var el = document.createElement('div');
        el.className = 'nx-db-card';
        el.innerHTML =
          '<div class="nx-db-card__media">' +
          (c.image ? '<img src="' + c.image + '" alt="' + c.name.replace(/"/g, '') + '" loading="lazy">' : '') +
          cardBadge(c) +
          (c.product && c.product.available ? '<span class="nx-db-card__buy">' + tr('inStore') + '</span>' : '') +
          '</div>' +
          '<p class="nx-db-card__name">' + c.name + '</p>' +
          '<p class="nx-db-card__meta">' + (c.energy != null ? tr('energyPrefix') + ' ' + c.energy : c.type) + '</p>';
        el.addEventListener('click', function () { openDetail(c); });
        grid.appendChild(el);
      });
    }

    var detailCard = null;

    function openDetail(c) {
      detailCard = c;
      var img = document.getElementById('nxDetailImg');
      img.src = c.image || '';
      img.alt = c.name;
      document.getElementById('nxDetailName').textContent = c.name;
      document.getElementById('nxDetailMeta').textContent = [
        c.type,
        c.energy != null ? tr('energyPrefix') + ' ' + c.energy : null,
        c.might != null ? tr('mightPrefix') + ' ' + c.might : null,
        c.rarity,
      ].filter(Boolean).join(' · ');
      document.getElementById('nxDetailDomains').textContent = (c.domains || []).length ? tr('domainsPrefix') + ' ' + c.domains.join(', ') : '';
      var buyEl = document.getElementById('nxDetailBuy');
      buyEl.textContent = c.product && c.product.available
        ? tr('inStorePriceTemplate', {price: c.product.price, currency: c.product.currency})
        : '';

      var isLegend = c.type === 'Legend';
      var isBattlefield = c.type === 'Battlefield';
      var isMainEligible = !isLegend && !isBattlefield && c.type !== 'Rune';
      document.getElementById('nxDetailQtyRow').style.display = (isLegend || isBattlefield) ? 'none' : 'flex';
      document.getElementById('nxDetailQtyInput').value = 1;
      document.getElementById('nxDetailAddBtn').textContent = isLegend
        ? tr('chooseAsChampion')
        : isBattlefield
        ? tr('addAsBattlefield')
        : tr('addToMainDeck');
      var sideboardBtn = document.getElementById('nxDetailSideboardBtn');
      sideboardBtn.style.display = isMainEligible ? 'block' : 'none';

      document.getElementById('nxCardDetail').hidden = false;
    }

    function closeDetail() {
      document.getElementById('nxCardDetail').hidden = true;
      detailCard = null;
    }

    document.getElementById('nxDetailClose').addEventListener('click', closeDetail);
    document.getElementById('nxDetailBackdrop').addEventListener('click', closeDetail);
    document.getElementById('nxCardDetail').addEventListener('click', function (e) {
      if (e.target === e.currentTarget) closeDetail();
    });
    document.getElementById('nxDetailQtyMinus').addEventListener('click', function () {
      var input = document.getElementById('nxDetailQtyInput');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    document.getElementById('nxDetailQtyPlus').addEventListener('click', function () {
      var input = document.getElementById('nxDetailQtyInput');
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
    // Copies of a main-deck-eligible card, counted across main + sideboard
    // combined (the "max 3 copies per card" rule applies deck-wide).
    function combinedCopies(id) {
      return (state.main[id] || 0) + (state.sideboard[id] || 0);
    }

    function addToMainEligible(bucket, id, qty) {
      var room = Math.max(0, RULES.maxCopies - combinedCopies(id));
      var toAdd = Math.min(qty, room);
      if (toAdd > 0) state[bucket][id] = (state[bucket][id] || 0) + toAdd;
    }

    document.getElementById('nxDetailAddBtn').addEventListener('click', function () {
      if (!detailCard) return;
      var wasChampionPick = detailCard.type === 'Legend' && view.mode === 'champion';
      if (detailCard.type === 'Legend') {
        state.champion = detailCard.id;
      } else if (detailCard.type === 'Battlefield') {
        state.battlefields[detailCard.id] = 1;
      } else if (detailCard.type === 'Rune') {
        var runeQty = Math.max(1, parseInt(document.getElementById('nxDetailQtyInput').value, 10) || 1);
        state.runes[detailCard.id] = (state.runes[detailCard.id] || 0) + runeQty;
      } else {
        var qty = Math.max(1, parseInt(document.getElementById('nxDetailQtyInput').value, 10) || 1);
        addToMainEligible('main', detailCard.id, qty);
      }
      render();
      closeDetail();
      if (wasChampionPick) {
        showWorkspace('battlefields');
      } else if (view.mode === 'champion') {
        renderChampionGrid();
      } else {
        renderGrid();
      }
    });

    document.getElementById('nxDetailSideboardBtn').addEventListener('click', function () {
      if (!detailCard) return;
      var qty = Math.max(1, parseInt(document.getElementById('nxDetailQtyInput').value, 10) || 1);
      addToMainEligible('sideboard', detailCard.id, qty);
      render();
      renderGrid();
      closeDetail();
    });

    // Any change made from the sidebar recap must also refresh the browsing
    // grid, since each card there shows a live badge (×N) reflecting the deck.
    function refreshAfterDeckChange() {
      render();
      if (view.mode === 'workspace') renderGrid();
    }

    function changeQty(bucket, id, delta) {
      var next = (state[bucket][id] || 0) + delta;
      if ((bucket === 'main' || bucket === 'sideboard') && delta > 0) {
        var otherBucket = bucket === 'main' ? 'sideboard' : 'main';
        var room = RULES.maxCopies - (state[otherBucket][id] || 0);
        next = Math.min(next, Math.max(0, room));
      }
      if (next <= 0) delete state[bucket][id];
      else state[bucket][id] = next;
      refreshAfterDeckChange();
    }

    function renderList(bucket, ulId, countId, singleCopy) {
      var ul = document.getElementById(ulId);
      ul.innerHTML = '';
      var total = 0;
      Object.keys(state[bucket]).forEach(function (id) {
        var qty = state[bucket][id];
        total += singleCopy ? 1 : qty;
        var c = cardById(id);
        if (!c) return;
        var li = document.createElement('li');
        if (singleCopy) {
          li.innerHTML = '<span>' + c.name + '</span><span><button type="button" class="nx-db-qty-btn" data-dir="remove">×</button></span>';
        } else {
          li.innerHTML =
            '<span>' + c.name + '</span>' +
            '<span>' +
            '<button type="button" class="nx-db-qty-btn" data-dir="-1">−</button>' +
            ' ' + qty + ' ' +
            '<button type="button" class="nx-db-qty-btn" data-dir="1">+</button>' +
            '<button type="button" class="nx-db-qty-btn" data-dir="remove" title="' + tr('removeTitle') + '">×</button>' +
            '</span>';
        }
        li.querySelectorAll('.nx-db-qty-btn').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var dir = btn.getAttribute('data-dir');
            if (dir === 'remove') { delete state[bucket][id]; refreshAfterDeckChange(); }
            else changeQty(bucket, id, parseInt(dir, 10));
          });
        });
        ul.appendChild(li);
      });
      document.getElementById(countId).textContent = total;
      return total;
    }

    function renderChampion() {
      var name = document.getElementById('nxChampionName');
      if (state.champion) {
        var c = cardById(state.champion);
        name.textContent = c ? c.name : state.champion;
      } else {
        name.textContent = tr('noChampionSelected');
      }
    }

    function validate(mainTotal, battlefieldTotal, runeTotal, sideboardTotal) {
      var statusEl = document.getElementById('nxDeckStatus');
      var strict = document.getElementById('nxStrictMode').checked;
      var messages = [];
      var ok = true;

      if (mainTotal !== RULES.main) { messages.push(tr('mainDeckCountTemplate', {count: mainTotal, total: RULES.main})); ok = false; }
      if (battlefieldTotal !== RULES.battlefields) { messages.push(tr('battlefieldCountTemplate', {count: battlefieldTotal, total: RULES.battlefields})); ok = false; }
      if (runeTotal !== RULES.runes) { messages.push(tr('runeCountTemplate', {count: runeTotal, total: RULES.runes})); ok = false; }
      if (sideboardTotal > RULES.sideboardMax) { messages.push(tr('sideboardTooManyTemplate', {count: sideboardTotal, max: RULES.sideboardMax})); ok = false; }
      if (!state.champion) { messages.push(tr('noChampionSelected')); ok = false; }

      var overCopies = Object.keys(state.main).filter(function (id) { return combinedCopies(id) > RULES.maxCopies; });
      if (overCopies.length > 0) { messages.push(tr('overCopiesTemplate', {count: overCopies.length, max: RULES.maxCopies})); ok = false; }

      var domainSet = {};
      [state.main, state.battlefields, state.runes, state.sideboard].forEach(function (bucket) {
        Object.keys(bucket).forEach(function (id) {
          var c = cardById(id);
          if (c) realDomains(c.domains).forEach(function (d) { domainSet[d] = true; });
        });
      });
      var champForColors = state.champion ? cardById(state.champion) : null;
      if (champForColors) realDomains(champForColors.domains).forEach(function (d) { domainSet[d] = true; });
      if (Object.keys(domainSet).length > RULES.maxColors) {
        messages.push(tr('domainsUsedTemplate', {count: Object.keys(domainSet).length, max: RULES.maxColors}));
        ok = false;
      }

      if (strict && state.champion) {
        var champ = cardById(state.champion);
        var allowedDomains = (champ && champ.domains) || [];
        var offDomain = [];
        Object.keys(state.main).concat(Object.keys(state.runes)).concat(Object.keys(state.sideboard)).forEach(function (id) {
          var c = cardById(id);
          if (!c) return;
          var cardDomains = realDomains(c.domains);
          var matches = cardDomains.length === 0 || cardDomains.some(function (d) { return allowedDomains.indexOf(d) !== -1; });
          if (!matches) offDomain.push(c.name);
        });
        if (offDomain.length > 0) {
          messages.push(tr('offDomainTemplate', {count: offDomain.length}));
          ok = false;
        }
      }

      statusEl.className = 'nx-db-status ' + (ok ? 'is-ok' : 'is-warn');
      statusEl.textContent = ok ? tr('deckValid') : messages.join(' · ');
      return ok;
    }

    function renderCurve() {
      var el = document.getElementById('nxCurve');
      var legendEl = document.getElementById('nxCurveLegend');
      if (!el) return;
      var buckets = [];
      var totals = [0, 0, 0, 0, 0, 0, 0]; // 0,1,2,3,4,5,6+
      for (var i = 0; i < 7; i++) buckets.push({});
      var domainsSeen = {};

      Object.keys(state.main).forEach(function (id) {
        var c = cardById(id);
        if (!c || c.energy == null) return;
        var idx = c.energy >= 6 ? 6 : c.energy;
        var domain = (c.domains && c.domains[0]) || 'Neutre';
        buckets[idx][domain] = (buckets[idx][domain] || 0) + state.main[id];
        totals[idx] += state.main[id];
        domainsSeen[domain] = true;
      });

      var max = Math.max.apply(null, totals.concat([1]));
      el.innerHTML = buckets.map(function (domainCounts, energy) {
        var total = totals[energy];
        var pct = Math.round((total / max) * 100);
        var label = energy === 6 ? '6+' : String(energy);
        var segments = Object.keys(domainCounts).sort().map(function (d) {
          var segPct = total > 0 ? Math.round((domainCounts[d] / total) * 100) : 0;
          var color = DOMAIN_COLORS[d] || DOMAIN_COLORS.Neutre;
          return '<div class="nx-db-curve__seg" style="height:' + segPct + '%; background:' + color + ';" title="' + d + ' : ' + domainCounts[d] + '"></div>';
        }).join('');
        return '<div class="nx-db-curve__col">' +
          '<span class="nx-db-curve__count">' + (total > 0 ? total : '') + '</span>' +
          '<div class="nx-db-curve__bar" style="height:' + (total > 0 ? Math.max(pct, 6) : 0) + '%">' + segments + '</div>' +
          '<span class="nx-db-curve__label">' + label + '</span>' +
          '</div>';
      }).join('');

      if (legendEl) {
        var domainKeys = Object.keys(domainsSeen).sort();
        legendEl.innerHTML = domainKeys.map(function (d) {
          var color = DOMAIN_COLORS[d] || DOMAIN_COLORS.Neutre;
          return '<span class="nx-db-curve-legend__item"><span class="nx-db-curve-legend__swatch" style="background:' + color + ';"></span>' + d + '</span>';
        }).join('');
      }
    }

    function updateTabCounts(mainTotal, battlefieldTotal, runeTotal) {
      var mainEl = document.getElementById('nxTabCountMain');
      var bfEl = document.getElementById('nxTabCountBattlefields');
      var runeEl = document.getElementById('nxTabCountRunes');
      if (mainEl) mainEl.textContent = mainTotal + '/' + RULES.main;
      if (bfEl) bfEl.textContent = battlefieldTotal + '/' + RULES.battlefields;
      if (runeEl) runeEl.textContent = runeTotal + '/' + RULES.runes;
    }

    function render() {
      renderChampion();
      var mainTotal = renderList('main', 'nxMainList', 'nxMainCount');
      var battlefieldTotal = renderList('battlefields', 'nxBattlefieldList', 'nxBattlefieldCount', true);
      var runeTotal = renderList('runes', 'nxRuneList', 'nxRuneCount');
      var sideboardTotal = renderList('sideboard', 'nxSideboardList', 'nxSideboardCount');
      renderCurve();
      updateTabCounts(mainTotal, battlefieldTotal, runeTotal);
      validate(mainTotal, battlefieldTotal, runeTotal, sideboardTotal);
    }

    function populateFilters() {
      var domains = {};
      var sets = {};
      var championDomains = {};
      cards.forEach(function (c) {
        (c.domains || []).forEach(function (d) { domains[d] = true; });
        if (c.set_id) sets[c.set_id] = c.set_label;
        if (c.type === 'Legend') realDomains(c.domains).forEach(function (d) { championDomains[d] = true; });
      });
      var domainSelect = document.getElementById('nxFilterDomain');
      while (domainSelect.options.length > 1) domainSelect.remove(1);
      Object.keys(domains).sort().forEach(function (d) {
        var opt = document.createElement('option');
        opt.value = d;
        opt.textContent = d;
        domainSelect.appendChild(opt);
      });
      var setSelect = document.getElementById('nxFilterSet');
      while (setSelect.options.length > 1) setSelect.remove(1);
      Object.keys(sets).forEach(function (id) {
        var opt = document.createElement('option');
        opt.value = id;
        opt.textContent = sets[id];
        setSelect.appendChild(opt);
      });
      var championDomainSelect = document.getElementById('nxChampionDomainFilter');
      while (championDomainSelect.options.length > 1) championDomainSelect.remove(1);
      Object.keys(championDomains).sort().forEach(function (d) {
        var opt = document.createElement('option');
        opt.value = d;
        opt.textContent = d;
        championDomainSelect.appendChild(opt);
      });
    }

    document.getElementById('nxSearch').addEventListener('input', renderGrid);
    document.getElementById('nxFilterType').addEventListener('change', renderGrid);
    document.getElementById('nxFilterDomain').addEventListener('change', renderGrid);
    document.getElementById('nxFilterSet').addEventListener('change', renderGrid);
    document.getElementById('nxChampionSearch').addEventListener('input', renderChampionGrid);
    document.getElementById('nxChampionDomainFilter').addEventListener('change', renderChampionGrid);
    document.getElementById('nxStrictMode').addEventListener('change', function () {
      render();
      if (view.mode === 'workspace') renderGrid();
    });
    document.getElementById('nxClearBtn').addEventListener('click', function () {
      state = {champion: null, main: {}, battlefields: {}, runes: {}, sideboard: {}};
      document.getElementById('nxDeckName').value = tr('newDeck');
      render();
      showChampionScreen();
    });

    function findCardByName(name) {
      var needle = name.trim().toLowerCase();
      return cards.find(function (c) { return c.name.toLowerCase() === needle; });
    }

    // Resolves an import line's card name, optionally suffixed with the
    // official "(SET-NUMBER)" code (e.g. "Volibear - Relentless Storm (OGN-249)").
    // The code disambiguates between base/alt-art/signature variants that
    // share the same display name.
    function findCardForImportLine(rawName) {
      var codeMatch = /\(([A-Za-z]+)-([A-Za-z0-9*]+)\)\s*$/.exec(rawName);
      var name = rawName.replace(/\([A-Za-z]+-[A-Za-z0-9*]+\)\s*$/, '').trim();

      if (codeMatch) {
        var prefix = (codeMatch[1] + '-' + codeMatch[2]).toLowerCase();
        var exactBase = cards.find(function (c) {
          if (!c.id) return false;
          var idLower = c.id.toLowerCase();
          return idLower.indexOf(prefix) === 0 && idLower.charAt(prefix.length) === '-';
        });
        if (exactBase) return exactBase;
        var anyVariant = cards.find(function (c) { return c.id && c.id.toLowerCase().indexOf(prefix) === 0; });
        if (anyVariant) return anyVariant;
      }

      return name ? findCardByName(name) : null;
    }

    // Section headers found in exported decklists (riftbound.gg writes
    // "Side Board:" before the sideboard). Cards listed after a sideboard
    // header go to the sideboard; any other known header switches back to the
    // main list. Matches the whole line only, so card names are never mistaken
    // for a header.
    var IMPORT_SIDEBOARD_HEADER = /^(side\s*-?\s*board|sb)\s*(\(\d+\))?\s*:?$/i;
    var IMPORT_OTHER_HEADER = /^(main\s*deck|deck|main|legend|champion|battlefields?|runes?|rune\s*deck)\s*(\(\d+\))?\s*:?$/i;

    function parseImportLines(lines) {
      var newState = {champion: null, main: {}, battlefields: {}, runes: {}, sideboard: {}};
      var unmatched = [];
      var inSideboard = false;

      lines.forEach(function (line) {
        if (IMPORT_SIDEBOARD_HEADER.test(line)) { inSideboard = true; return; }
        if (IMPORT_OTHER_HEADER.test(line)) { inSideboard = false; return; }

        var match = /^(\d+)\s*x?\s+(.+)$/i.exec(line);
        var qty = match ? parseInt(match[1], 10) : 1;
        var name = match ? match[2] : line;
        var card = findCardForImportLine(name);
        if (!card) { unmatched.push(line); return; }
        if (card.type === 'Legend') {
          newState.champion = card.id;
        } else if (card.type === 'Battlefield') {
          newState.battlefields[card.id] = 1;
        } else if (card.type === 'Rune') {
          newState.runes[card.id] = (newState.runes[card.id] || 0) + qty;
        } else {
          // "Max 3 copies per card" applies to main + sideboard combined
          // (same rule as addToMainEligible/changeQty).
          var bucket = inSideboard ? 'sideboard' : 'main';
          var used = (newState.main[card.id] || 0) + (newState.sideboard[card.id] || 0);
          var toAdd = Math.min(qty, Math.max(0, RULES.maxCopies - used));
          if (toAdd > 0) newState[bucket][card.id] = (newState[bucket][card.id] || 0) + toAdd;
        }
      });

      return {state: newState, unmatched: unmatched};
    }

    function openImportModal() {
      document.getElementById('nxImportResult').style.display = 'none';
      document.getElementById('nxImportModal').hidden = false;
    }
    function closeImportModal() {
      document.getElementById('nxImportModal').hidden = true;
    }

    document.getElementById('nxImportBtn').addEventListener('click', openImportModal);
    document.getElementById('nxImportClose').addEventListener('click', closeImportModal);
    document.getElementById('nxImportBackdrop').addEventListener('click', closeImportModal);
    document.getElementById('nxImportModal').addEventListener('click', function (e) {
      if (e.target === e.currentTarget) closeImportModal();
    });

    document.getElementById('nxImportSubmit').addEventListener('click', function () {
      if (cards.length === 0) {
        var resultEl = document.getElementById('nxImportResult');
        resultEl.textContent = tr('loadingCardsRetry');
        resultEl.style.display = 'block';
        return;
      }

      var text = document.getElementById('nxImportText').value;
      var lines = text.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
      var parsed = parseImportLines(lines);
      var newState = parsed.state;
      var unmatched = parsed.unmatched;

      state = newState;
      render();
      closeImportModal();
      if (state.champion) {
        showWorkspace('main');
      } else {
        showChampionScreen();
      }

      var resultEl = document.getElementById('nxImportResult');
      if (unmatched.length > 0) {
        resultEl.textContent = tr('unmatchedLinesTemplate', {
          count: unmatched.length,
          list: unmatched.slice(0, 5).join(' · ') + (unmatched.length > 5 ? '…' : ''),
        });
        resultEl.style.display = 'block';
        openImportModal();
      }
    });

    function buildDeckObject() {
      return {
        id: (crypto.randomUUID ? crypto.randomUUID() : String(Date.now())),
        name: document.getElementById('nxDeckName').value || tr('unnamedDeck'),
        champion: state.champion,
        main: Object.keys(state.main).map(function (id) { return {id: id, qty: state.main[id]}; }),
        battlefields: Object.keys(state.battlefields).map(function (id) { return {id: id, qty: 1}; }),
        runes: Object.keys(state.runes).map(function (id) { return {id: id, qty: state.runes[id]}; }),
        sideboard: Object.keys(state.sideboard).map(function (id) { return {id: id, qty: state.sideboard[id]}; }),
        created_at: new Date().toISOString(),
      };
    }

    var saveBtn = document.getElementById('nxSaveBtn');
    if (config.customerLoggedIn) {
      saveBtn.disabled = false;
      saveBtn.textContent = tr('savedAccountButton');
    }
    saveBtn.addEventListener('click', function () {
      if (!config.customerLoggedIn) return;
      var encoded = encodeURIComponent(JSON.stringify(buildDeckObject()));
      window.location.href = config.saveUrl + '?save=' + encoded;
    });

    var missingBtn = document.getElementById('nxMissingBtn');
    if (config.customerLoggedIn) missingBtn.disabled = false;
    missingBtn.addEventListener('click', function () {
      if (!config.customerLoggedIn) return;
      var encoded = encodeURIComponent(JSON.stringify(buildDeckObject()));
      window.location.href = config.collectionUrl + '?check=' + encoded + '&game=riftbound';
    });

    var shareBtn = document.getElementById('nxShareBtn');
    shareBtn.addEventListener('click', function () {
      var encoded = encodeURIComponent(JSON.stringify(buildDeckObject()));
      var url = window.location.origin + window.location.pathname + '?load=' + encoded;
      var restoreLabel = shareBtn.textContent;
      function flash(text) {
        shareBtn.textContent = text;
        setTimeout(function () { shareBtn.textContent = restoreLabel; }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { flash(tr('linkCopied')); }).catch(function () { window.prompt(tr('copyLinkPrompt'), url); });
      } else {
        window.prompt(tr('copyLinkPrompt'), url);
      }
    });

    function showCompleteStatus(text) {
      var el = document.getElementById('nxCompleteStatus');
      el.textContent = text;
      el.style.display = 'block';
    }

    var nxCompleteBtn = document.getElementById('nxCompleteBtn');
    if (nxCompleteBtn) nxCompleteBtn.addEventListener('click', function () {
      var entries = Object.keys(state.main).map(function (id) { return {id: id, qty: state.main[id]}; })
        .concat(Object.keys(state.battlefields).map(function (id) { return {id: id, qty: 1}; }))
        .concat(Object.keys(state.runes).map(function (id) { return {id: id, qty: state.runes[id]}; }))
        .concat(Object.keys(state.sideboard).map(function (id) { return {id: id, qty: state.sideboard[id]}; }));
      if (state.champion) entries.push({id: state.champion, qty: 1});

      var lines = [];
      var missing = [];
      entries.forEach(function (entry) {
        var c = cardById(entry.id);
        if (!c) return;
        if (c.product && c.product.available && c.product.variantId) {
          var numericId = c.product.variantId.split('/').pop();
          lines.push({id: parseInt(numericId, 10), quantity: entry.qty});
        } else {
          missing.push(c.name);
        }
      });

      if (lines.length === 0) {
        showCompleteStatus(tr('noCardsAvailable'));
        return;
      }

      showCompleteStatus(tr('addingToCart'));
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: lines}),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            showCompleteStatus(tr('cartErrorTemplate', {message: data.description || data.message || tr('addImpossible')}));
            return;
          }
          var msg = tr('itemsAddedTemplate', {count: lines.length});
          if (missing.length) {
            msg += tr('cardsNotYetAvailableTemplate', {
              count: missing.length,
              list: missing.slice(0, 5).join(', ') + (missing.length > 5 ? '…' : ''),
            }) + '.';
          }
          showCompleteStatus(msg);
        })
        .catch(function () {
          showCompleteStatus(tr('networkError'));
        });
    });

    render();
    updateTabsUI();

    var loadingEl = document.getElementById('nxLoading');
    loadAllCards(function () {
      if (loadingEl) { loadingEl.remove(); loadingEl = null; }
      populateFilters();
      render();
      if (state.champion) {
        showWorkspace(view.mode === 'workspace' ? view.tab : 'main');
      } else {
        showChampionScreen();
      }
    }).catch(function () {
      if (loadingEl) loadingEl.textContent = tr('loadCardsError');
      var champLoading = document.getElementById('nxChampionLoading');
      if (champLoading) champLoading.textContent = tr('loadChampionsError');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-game-guide"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.nx-guide-tabs').forEach(function (tabs) {
      tabs.querySelectorAll('.nx-guide-tabs__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-tab');
          tabs.querySelectorAll('.nx-guide-tabs__btn').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
          });
          var wrap = tabs.closest('.nx-wrap');
          wrap.querySelectorAll('.nx-guide-panel').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-panel') === target);
          });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
